// src/features/hmi-simulator/components/shared/Header.tsx
import React from 'react';
import { Paper, Box, Typography, Chip, Button, IconButton } from '@mui/material';
import { Wifi, WifiOff, VpnKey } from '@mui/icons-material';
import { HMIConfig } from '../../types';

interface HeaderProps {
  config: HMIConfig;
  language: string;
  setLanguage: (lang: string) => void;
  isOnline: boolean;
  deviceId?: string;
  onSettingsClick: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  config,
  language,
  setLanguage,
  isOnline,
  deviceId,
  onSettingsClick
}) => (
  <Paper elevation={1} sx={{ borderRadius: 0 }}>
    <Box sx={{ px: 3, py: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {config.logoBase64 ? (
          <img src={config.logoBase64} alt="Hotel Logo" style={{ height: 40 }} />
        ) : (
          <Typography variant="h6">{config.hotelName}</Typography>
        )}
        <Chip
          icon={isOnline ? <Wifi /> : <WifiOff />}
          label={deviceId || 'Not Provisioned'}
          color={isOnline ? 'success' : 'default'}
          size="small"
          variant="outlined"
        />
      </Box>
      
      <Box sx={{ display: 'flex', gap: 1 }}>
        {config.availableLanguages.map(lang => (
          <Button
            key={lang}
            onClick={() => setLanguage(lang)}
            variant={language === lang ? 'contained' : 'outlined'}
            size="small"
            sx={{
              minWidth: 40,
              backgroundColor: language === lang ? config.primaryColor : undefined,
              '&:hover': {
                backgroundColor: language === lang ? config.primaryColor : undefined,
              }
            }}
          >
            {lang}
          </Button>
        ))}
        
        <IconButton onClick={onSettingsClick} size="small">
          <VpnKey />
        </IconButton>
      </Box>
    </Box>
  </Paper>
);